import React from "react";

export default function KpiGrid({ items = [] }) {
  const accentClass = (accent) => {
    switch (accent) {
      case "amber":
        return "accent-warning";
      case "coral":
        return "accent-warning";
      case "turquoise":
      case "aqua":
      case "green":
        return "accent-success";
      case "violet":
      default:
        return "accent-neutral";
    }
  };

  return (
    <div className="management-card mb-4">
      <div className="management-stats-grid secretaria-kpi-grid">
        {items.map((item) => (
          <div key={item.key} className={`management-stat-card ${accentClass(item.accent)}`}>
            <div className="management-stat-icon">
              <i className={`bi ${item.icon || "bi-circle"}`} />
            </div>
            <div>
              <p className="management-stat-label mb-1">{item.label}</p>
              <div className="management-stat-value">{item.value}</div>
              {item.trend && <small className="text-muted">{item.trend}</small>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
